<template>
  <div class="data-block-container">
      <p class="value-to-display"  v-bind:class="[ size === 'big' ? 'big-value' : size === 'medium' ? 'medium-value' : 'mini-value']">{{ dataToShow.value | upper}}</p>
      <p class="key-to-display">{{ dataToShow.key | capitalize }}</p>
  </div>
</template>

<script>
  export default {
    props: {
      dataToShow: {
          type: Object,
          default: () => ({key: '', value: ''})
      },
      size: {
        type: String,
        default: 'big'
      }
    },
    data() {
      return {
        msg: 'Hi there!'
      }
    }
  }
</script>

<style scoped>
  .data-block-container {
    margin-bottom: 24px;
  }

  .value-to-display {
    font-weight: bold;
    margin: 0px;
  }

  .big-value {
    font-size: 24px;
  }

  .medium-value {
    font-size: 18px;
  }

  .mini-value {
    font-size: 14px;
    font-weight: 500;
  }

  .key-to-display {
    font-size: 12px;
    opacity: 0.6;
    margin: 0px;

  }
</style>